import { TGetChipSizeProps } from '../chips.types';

const getChipIconSize = ({ shape, size, type }: TGetChipSizeProps): number => {
  if (type === 'info') {
    if (size === 24) return 12;

    if (size === 32) return 16;

    if (size === 40) {
      const isRound = shape === 'round';
      if (isRound) {
        return 16;
      }
      return 20;
    }
  }

  return 12;
};

export default getChipIconSize;
